import styled from "styled-components";

export const UploadToS3WithDropzoneStyled = styled.div`
  text-align:center;
`;
